import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useVariantSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(
    () =>
      Object.keys(state.splitTests)
        .flatMap(k => state.splitTests[k]?.variants ?? [])
        .find(s => s.messageId === id),
    [id, state.splitTests],
  );
};
